import { render, staticRenderFns } from "./ViewAll.vue?vue&type=template&id=1c2a8678"
import script from "./ViewAll.vue?vue&type=script&lang=js"
export * from "./ViewAll.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports